import CircularProgress from "@mui/material/CircularProgress";
import { Flex } from "./Core/Flex";

export const Loader = () => (
  <Flex justifyContent="center" alignItems="center" minHeight="20vh">
    <CircularProgress color="primary" />
  </Flex>
);
